import services from '../../../services'
import * as types from '../../mutation-types'

// const moduleName = 'menu'
// const lastUpdateTimeKey = `__module_${moduleName}_last_update_time__`
// const timeGap = 5 * 60 * 1000

const state = {
  menuTreeData: []
}
/*eslint-disable*/
const actions = {
  async getMenuTree ({ commit }, query) {
    // if (!query.force) {
    //   let lastUpdateTime = state.menuTreeData[lastUpdateTimeKey] || 0
    //   if (Date.now() - lastUpdateTime < timeGap && state.menuTreeData.length > 0) {
    //     return Promise.resolve(state.menuTreeData)
    //   }
    // } else {
    //   delete query.force
    // }
    if (query) {
      // 原先的peopleId，在多租户版本中对应人员的身份信息；接口改造后，可通过identityId，或peopleId+tenantId查询
      // iobp中会加上peopleId，所以archdata中会接受到以上三个参数，判断逻辑优先用peopleId+tenantId查询
      query = Object.assign({ system: ['基础平台', '智慧会议', '智慧出入', '智慧空间', '运营平台'] }, { identityId: query.peopleId })
    }
    let p = query ? services.menu_getMenuTree({ params: query }) : services.menu_getMenuTree()
    return await p.then(res => {
      commit(types.MENU_MENUTREEDATA, res)
      return res
    })
  },
  async getAllMenuTree ({ commit }, query) {
    return await services.menu_getAllMenuTree(query)
  },
  async getMenuList ({ commit }, query) {
    return await services.menu_getMenuList(query)
  },
  async addMenu ({ commit }, options) {
    return await services.menu_add(options)
  },
  async updateMenu ({ commit }, options) {
    return await services.menu_update(options._id, options)
  },
  async deleteMenu ({ commit }, query) {
    return await services.menu_delete(query)
  },
  async getMenuTemplateTree ({ commit }, query) {
    return await services.menu_getMenuTemplateTree(query)
  }
}

const mutations = {
  [types.MENU_MENUTREEDATA] (state, payload) {
    let menuTree = payload || []
    // menuTree[lastUpdateTimeKey] = Date.now()
    state.menuTreeData = menuTree
  }
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/menu.js